import React, { useState } from "react";
import { useAuth } from "../AuthContext";
import api, { apiError } from "../api";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";

const black = "#111111";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Autentificare reusita");
    } catch (err) {
      toast.error(apiError(err, "Autentificare esuata"));
    } finally {
      setLoading(false);
    }
  };

  const submitForgot = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: forgotEmail });
      setForgotSent(true);
      toast.success("Daca exista un cont, primesti un email cu linkul de resetare");
    } catch (err) {
      toast.error(apiError(err, "Cerere esuata"));
    } finally {
      setForgotLoading(false);
    }
  };

  const inputCls = "w-full mb-4 px-3 py-2 rounded-md border border-gray-300 outline-none focus:border-gray-500";

  if (forgot) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6"
        style={{ backgroundColor: "#ffffff", color: black, fontFamily: "Arial, sans-serif", fontSize: "12px" }}>
        <form onSubmit={submitForgot} className="w-full max-w-sm" data-testid="forgot-form">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-9 h-9 rounded-md border border-gray-300 flex items-center justify-center">
              <Mail className="w-5 h-5" style={{ color: black }} />
            </div>
            <span style={{ fontSize: "18px" }} className="font-bold">YVOLA</span>
          </div>
          <h2 style={{ fontSize: "20px" }} className="font-bold">Ai uitat parola?</h2>
          <p className="mt-1 mb-8" style={{ fontSize: "13px" }}>
            Introdu emailul contului si iti trimitem un link de resetare.
          </p>
          {forgotSent ? (
            <p data-testid="forgot-sent-msg" style={{ fontSize: "13px" }} className="mb-6">
              Daca exista un cont cu acest email, vei primi un link de resetare. Verifica si folderul spam.
            </p>
          ) : (
            <>
              <label className="block mb-1" style={{ fontSize: "13px" }}>Email</label>
              <input data-testid="forgot-email-input" type="email" required value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)} className={inputCls} placeholder="email@firma.ro" />
              <button data-testid="forgot-submit-button" type="submit" disabled={forgotLoading}
                className="w-full flex items-center justify-center gap-2 py-2.5 rounded-md text-white font-medium disabled:opacity-60"
                style={{ backgroundColor: black, fontSize: "13px" }}>
                {forgotLoading && <Loader2 className="w-4 h-4 animate-spin" />}
                Trimite link de resetare
              </button>
            </>
          )}
          <p className="mt-5 text-center" style={{ fontSize: "13px" }}>
            <button type="button" className="underline" data-testid="forgot-back-to-login"
              onClick={() => { setForgot(false); setForgotSent(false); }}>
              Inapoi la autentificare
            </button>
          </p>
        </form>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ backgroundColor: "#ffffff", color: black, fontFamily: "Arial, sans-serif", fontSize: "12px" }}
    >
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-md border border-gray-300 flex items-center justify-center">
            <Mail className="w-5 h-5" style={{ color: black }} />
          </div>
          <span style={{ fontSize: "18px" }} className="font-bold">YVOLA</span>
        </div>
        <h2 style={{ fontSize: "20px" }} className="font-bold">Bine ai revenit</h2>
        <p className="mt-1 mb-8" style={{ fontSize: "13px" }}>Conecteaza-te in contul tau Yvola.</p>

        <label className="block mb-1" style={{ fontSize: "13px" }}>Email</label>
        <input
          data-testid="login-email-input"
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          className={inputCls}
          placeholder="admin@yvola.eu"
        />
        <label className="block mb-1" style={{ fontSize: "13px" }}>Parola</label>
        <input
          data-testid="login-password-input"
          type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          className={inputCls}
          placeholder="parola"
        />
        <div className="mb-4 text-right">
          <button type="button" className="underline" style={{ fontSize: "12px" }}
            data-testid="login-forgot-link" onClick={() => setForgot(true)}>
            Am uitat parola
          </button>
        </div>
        <button
          data-testid="login-submit-button"
          type="submit" disabled={loading}
          className="w-full flex items-center justify-center gap-2 py-2.5 rounded-md text-white font-medium disabled:opacity-60"
          style={{ backgroundColor: black, fontSize: "13px" }}
        >
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          Autentificare
        </button>
        <p className="mt-5 text-center" style={{ fontSize: "13px" }}>
          Nu ai cont de firma? <a href="/signup" className="underline" data-testid="login-to-signup">Inregistreaza firma</a>
        </p>
      </form>
    </div>
  );
}
